/**
 * SvgOverlays — positions all svg_overlay() panels as HTML overlays on top of
 * the main viewer canvas.
 *
 * Rendered as a sibling to <SceneCanvas> inside the same relative container,
 * following the same pattern as PiPOverlays. The container spans the full
 * viewer area; each SvgOverlay child is absolutely positioned within it.
 *
 * No drag-and-drop, no resize, no click handlers — SVG overlays are purely
 * decorative and non-interactive.
 */

import type { SvgOverlay as SvgOverlayType } from '@/worker/types';
import type { ProjectFile } from '@/components/files/FileManager';
import { SvgOverlay } from './SvgOverlay';

interface SvgOverlaysProps {
  overlays: SvgOverlayType[];
  projectFiles: ProjectFile[];
}

export function SvgOverlays({ overlays, projectFiles }: SvgOverlaysProps) {
  if (overlays.length === 0) return null;

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {overlays.map((overlay, i) => (
        <SvgOverlay key={i} overlay={overlay} projectFiles={projectFiles} />
      ))}
    </div>
  );
}
